/**
 * 全局插件方案
 * 关联工单[https://kb.fzyun.net/issues/669780]
 * common-mediax/src/common/DialogWatcherPlugin.js
 * 
 * 监听 el-dialog 组件的打开和关闭事件，并添加一个 loading 图标到确认按钮上
 * 此方案，只能覆盖常规 el-dialog 组件，个性化的需要在业务中，单独去处理
 * 
 * 接入步骤：
 * 1.main项目 main.js文件，引入此插件，并注册
 *  import 'common-mediax/src/common/DialogWatcherPlugin';
 *  Vue.use(window.dialogWatcherPlugin)
 * 2.需要用到得子项目，在 main.js 中注册
 *  Vue.use(window.dialogWatcherPlugin)
 * 3.在个性化的 el-dialog 组件中，隐藏 loading，可用直接隐藏(此插件不能直接隐藏得，用 这个方法隐藏)
 *  window.dialogWatcherPlugin.hideLoading()
 * 
 * 4. common-mediax/src/common/axios.js 中配置
 * axios中，在请求拦截器/响应拦截器，处理 loading 得展示/隐藏
 * axios.interceptors.request.use((config) => {
 *   window.dialogWatcherPlugin.showLoading()
 *   // ...
 * })
 * axios.interceptors.response.use(
 * (response) => {
 *  if (response.data.status != 0) {
 *    // 点击'确定'，时，为了兼容 连续调好几个接口，才能把这个'任务'做完。故，只要是成功就一直展示loading
 *    // 最终成功的关闭loading，放到插件中监听 弹框 关闭后，将相关的标签移除
 *    window.dialogWatcherPlugin.hideLoading()
 *  } else {
 *    // 这块是 兼容 一种特殊情况，返回 false 时，业务中代表的时失败/错误/...，所以要隐藏 loading
 *    if(response.data.data == false) {
 *       window.dialogWatcherPlugin.hideLoading()
 *    }
 *    // 有什么特殊情况，可扩展...
 *  }
 *  // ...
 * },
 * (error) => {
 *   window.dialogWatcherPlugin.hideLoading()
 * })
 * 
 * 5.此插件是一个最基础的方案，提供一个思路，可扩展/优化
 * 
 * @author zhangkaicheng
 * @date 2025-01-21
 */
(function() {
  const dialogWatcherPlugin = {};
  dialogWatcherPlugin.install = function(Vue) {
    // 创建一个全局mixin
    Vue.mixin({
      mounted() {
        // 如果当前组件是 el-dialog 或者包含 el-dialog 的组件
        if (this.$options.name === 'ElDialog') {
          this.__dialogWatchHandler__ = () => {
            if (this.visible) {
              // 初始化要查看有没有指定得 loadingIcon
              this.__removeLoadingIcon__()
              if (this.$el && this.$el.querySelector) {
                setTimeout(() => {
                  this.__setupConfirmButtonListeners__()
                }, 500);
              }
            } else {
              // 不能都移除，只能移除指定的 loadingIcon，因为会涉及到，el-dialog 组件的嵌套
              this.__removeLoadingIcon__()
            }
          };
          // 监听 visible 属性的变化
          this.$watch('visible', this.__dialogWatchHandler__);
        }
      },
      destroyed() {
        // 清理监听器
        if (this.__dialogWatchHandler__) {
          this.$destroy();
        }
        // 销毁 confirmButton 的监听器
        if (this.__confirmButtons__) {
          this.__confirmButtons__.forEach(button => {
            button.removeEventListener('click', this.__handleButtonClick__.bind(this, button));
          });
        }
      },
      methods: {
        // 点击的时候在'确定'后，创建loadingIcon
        __handleButtonClick__(button) {
          const dialogFooter = button.closest('.el-button--primary');
          if (dialogFooter) {
            let loadingIcon = dialogFooter.querySelector('.loading-icon-custom');
            if (!loadingIcon) {
              loadingIcon = document.createElement('i');
              loadingIcon.className = `el-icon-loading loading-icon loading-icon-custom loading-icon-custom-${this._uid}`;
              dialogFooter.appendChild(loadingIcon);
            }
            loadingIcon.style.display = 'none';
          }
        },
        // 移除指定el-dialog中的 loadingIcon
        __removeLoadingIcon__() {
          const loadingIcons = document.querySelectorAll(`.el-icon-loading.loading-icon.loading-icon-custom.loading-icon-custom-${this._uid}`);
          loadingIcons.forEach(icon => icon.remove());
        },
        // 查找确认按钮并添加点击事件监听器
        __setupConfirmButtonListeners__() {
          const confirmButtons1 = this.$el.querySelectorAll(
            '.el-dialog .el-dialog__body .dialog-content .btns .el-button--primary');
          const confirmButtons2 = this.$el.querySelectorAll(
            '.el-dialog .el-dialog__footer .dialog-footer .el-button--primary');
          const confirmButtons3 = this.$el.querySelectorAll(
            '.el-dialog .el-dialog__footer .el-button--primary');
          // 有不一样的路径，可以直接追加
          // 兼容【3.2.4】已做过的话，这需要过滤掉，相关的标签
          const allConfirmButtons = Array.from(confirmButtons1).concat(Array.from(confirmButtons2)).concat(Array.from(confirmButtons3));
          allConfirmButtons.forEach(button => {
            button.addEventListener('click', this.__handleButtonClick__.bind(this, button));
          });
          this.__confirmButtons__ = allConfirmButtons;
        }
      }
    });
  };
  // 显示
  dialogWatcherPlugin.showLoading = function() {
    setTimeout(() => {
      let loadingIcon = document.querySelector('.el-icon-loading.loading-icon.loading-icon-custom');
      if (loadingIcon) {
        loadingIcon.style.display = 'inline-block';
      }
    }, 100)
  }
  // 隐藏
  dialogWatcherPlugin.hideLoading = function() {
    let loadingIcon = document.querySelector('.el-icon-loading.loading-icon.loading-icon-custom');
    if (loadingIcon) {
      loadingIcon.style.display = 'none';
    }
  }
  // 移除
  dialogWatcherPlugin.removeAllLoadingIcons = function() {
    const loadingIcons = document.querySelectorAll('.el-icon-loading.loading-icon.loading-icon-custom');
    loadingIcons.forEach(icon => icon.remove());
  }
  // 将插件暴露给全局变量，供各个子项目注册
  window.dialogWatcherPlugin = dialogWatcherPlugin;
})();